import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { Identity } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { Transport } from '../../../common/model/transport.model';
import { EditTransport } from '../edit-transport.model';

@Injectable({
  providedIn: 'root'
})
export class EditTransportService {

  constructor(private appServerAPI: AppServerAPI) { }

  getTransport(identity: Identity): Observable<Transport> {
    return this.appServerAPI.execute<Transport>(`/client/control/change/transport/get`, identity);
  }

  save(editTransport: EditTransport): Observable<ServiceResponse> {
    return this.appServerAPI.execute(`/client/control/change/transport/save`, editTransport);
  }

  findCarriersStartingByName(name: string): Observable<string[]> {
    return this.appServerAPI.execute(`/client/control/change/transport/carriers-by-name`, name);
  }

  findString1StartingWith(name: string): Observable<string[]> {
    return this.appServerAPI.execute(`/client/control/change/transport/string1`, name);
  }

  findNumberPlatesStartingWith(name: string): Observable<string[]> {
    return this.appServerAPI.execute(`/client/control/transport/registration/numberplates`, name);
  }

}
